import { Component, Vue, Watch } from 'vue-property-decorator';
import { teamsStore, athleteProfile } from '@/store';
import { TeamModel } from '@/models/team';
import { isEmpty } from '@/pipes';
import { coachApi } from '@/api/CoachApi';

@Component
export class MyTeamsMixin extends Vue {
	reloadMyTeams: boolean = false;
	$auth: {
		athleteId: string,
		coachId: string,
	};
	get MyTeamsInitialized(): boolean{
		return teamsStore.myTeamsInitialized;
	}
	get MyTeamsLoading(): boolean{
		return teamsStore.myTeamsLoading;
	}
	get MyTeams(): TeamModel[]{
		return teamsStore.myTeams;
	}
	get MyActiveTeams(): Array<TeamModel> {
		return this.MyTeams.filter(t => !t.archive);
	}
	MyTeamsSorted(teamOrder: Array<string>): Array<TeamModel> {
		if( isEmpty(teamOrder) ) return this.MyActiveTeams;

		let teams: Array<TeamModel> = [];
		for( const teamId of teamOrder ) {
			if( isEmpty(teamId) ) continue;
			const foundTeam = this.MyActiveTeams.find(t => t.id === teamId);
			if( isEmpty(foundTeam) ) continue;
			teams.push(foundTeam);
		}

		if( teams.length !== this.MyActiveTeams.length ) {
			for( const team of this.MyActiveTeams ) {
				const foundTeam = teams.find(t => t.id === team.id);
				if( !foundTeam ) {
					teams.push(team);
				}
			}
			coachApi.patch({id: this.$auth.coachId, teams: teams.map(t => t.id)});
		}

		return teams;
	}

	get NumTeams(): number {
		return this.MyActiveTeams.length;
	}
	get HasTeams(): boolean {
		return this.NumTeams > 0;
	}

	get HasAthleteTeams(): boolean {
		return this.MyAthleteTeams.length > 0;
	}
	get MyAthleteTeams(): TeamModel[]{
		return athleteProfile.athleteProfileTeams;
	}
	get MyAthleteCurrentTeam(): TeamModel {
		if( !this.HasAthleteTeams ) return undefined;
		return this.MyAthleteTeams[this.MyAthleteTeams.length - 1];
	}
	get MyAthleteId(): string {
		return athleteProfile.athleteProfile?.id;
	}

	created() {
		this.initMyTeams();
	}

	@Watch('$auth.athleteId')
	async reloadTeams() {
		this.reloadMyTeams = true;
		await this.initMyTeams();
	}

	async initMyTeams() {
		if (this.reloadMyTeams || !teamsStore.myTeamsInitialized && this.$auth.coachId) {
			await teamsStore.loadMyTeams(this.$auth.coachId);
		}
		if (this.reloadMyTeams || !athleteProfile.athleteProfileInitialized && this.$auth.athleteId) {
			await athleteProfile.getAthleteProfile(this.$auth.athleteId);
		}
	}
}
